import { useMemo } from 'react';
import { doc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { useAuthContext } from '../../auth/useAuthContext';
import { CLOUD_FUNCTIONS, DB } from '../../auth/FirebaseContext';
import { cloud_makeSalesforceRequest } from '../../utils/mrr/cloudFunctions';
import { endpoint_getPortalNotifications } from '../../utils/mrr/cloudEndpointNames';

//NOTE: This hook encapsulates the behavior specific to the app implementing this lib.

export const portalNotificationsFirestoreKey = 'users';
export const usePortalNotificationsFetcher = () => {
  const { user } = useAuthContext();
  const docRef = useMemo(() => {
    if (user === null) {
      return null;
    }
    return doc(DB, portalNotificationsFirestoreKey, user.id);
  }, [user]);

  const handleRequest = async () => {
    const cloudFunction = httpsCallable(
      CLOUD_FUNCTIONS,
      cloud_makeSalesforceRequest + '?' + endpoint_getPortalNotifications
    );

    const data = {
      method: 'GET',
      path: '/api/guest/notifications/portalNotification',
      params: {},
      body: '',
    };

    const result = await cloudFunction(data);

    // Validate response structure
    if (!result.data) {
      throw new Error('Failed to get portal notifications.');
    }

    const responseData = result.data as any;

    // Check for portal_notifications array
    if (!Array.isArray(responseData.portal_notifications)) {
      throw new Error('Failed to read notifications.');
    }

    return responseData.portal_notifications;
  };

  return useMemo(() => ({ docRef, handleRequest }), [docRef]);
};
